
import { useLocation  } from 'react-router';
import { useNavigate } from "react-router-dom";
import { useContext} from 'react'
import systemContext from '../../AppState/SystemConfig/appContext';
import { useEffect,useState } from 'react';
import TokenValidateDialog from './tokenValidateDialog.jsx';
import { Box } from '@mui/material';


function  UserAccess() {
    const {AppManager} =useContext(systemContext);
    const {search}= useLocation()
    const navigate = useNavigate();

    const [validated, setValidated] = useState(false);
    const [isLoading, setisLoading ] = useState(false);
    prompt.setPerfil = (arry) => {
    //   alert("validado")
    setisLoading(false)
  
     if(arry!=""){
        setValidated(true)
        setTimeout(() => {
          navigate("/dashboard");
        }, 3000);
     }else{
        setValidated(false)
        setTimeout(() => {
            navigate("/login");
          }, 3000);
     }
      };
    useEffect(() => {
        if(search){
            const queryParams = new URLSearchParams(search);
    
            // Obtener el valor del parámetro "token" de los query params
            const token = queryParams.get('token');
            // let splited=search.split("?")
            // // let token=splited[0]
            // // let credencial=splited[1]
            
            // // const paramSplited=token.split("=") //Obtenemos el texto
            // // const paramSplited2=credencial.split("=")
            
            // token=paramSplited[1]
            // // credencial=paramSplited2[1]
            // // alert(`${paramSplited[1]},${paramSplited2[1]}`)
        
            AppManager.setToken(token)  
            AppManager.setQrLogin()  
           
            if (!AppManager.loadingProfile) {
                if(!isLoading){
                    setisLoading(true)
                }
                AppManager.loadProfile(prompt);
              }
            // navigate("/loading");
        }

        return () => {
            // cleanup
            setValidated(false)
        }
    }, [])

    return (      

        <Box>
        <TokenValidateDialog validated={validated} isloading={isLoading}></TokenValidateDialog>
        </Box>
    )
}

export default  UserAccess;